import { AI_CAPTURE_MAX_IMAGE_LENGTH } from '@repo/lib';
import { z } from '../zod';

const AI_CAPTURE_IMAGE = /^data:image\/(?:jpeg|png);base64,[A-Za-z0-9+/]+={0,2}$/;

const pixels = z.number().int().positive().max(100_000);

export const AiChatCaptureBodyValidationSchema = z.object({
  requestId: z.uuid(),
  image: z
    .string()
    .max(AI_CAPTURE_MAX_IMAGE_LENGTH)
    .regex(AI_CAPTURE_IMAGE, 'Must be a JPEG or PNG data URL')
    .optional()
    .meta({
      description:
        "Left out when the dashboard couldn't capture the preview, so the AI stops waiting for it.",
    }),
  width: pixels
    .optional()
    .meta({ description: 'The width the preview was laid out at, in CSS pixels.' }),
  height: pixels
    .optional()
    .meta({ description: 'How much of the preview the image shows, from the top.' }),
  fullHeight: pixels.optional(),
});

export type AiChatCaptureBody = z.infer<typeof AiChatCaptureBodyValidationSchema>;
